import FormFieldValidation from "../../../enums/FormFieldValidation";
import IInvite from "../../../models/invite/IInvite";

interface IInviteeValidation {
    firstName: FormFieldValidation;
    lastName: FormFieldValidation;
    emailAddress: FormFieldValidation;
    duration: FormFieldValidation;
}

interface IInviteValidation {
    invitees: IInviteeValidation[];
    reason: FormFieldValidation;
}

const createInviteeValidation = (): IInviteeValidation => ({
    firstName: FormFieldValidation.NOT_VALIDATED,
    lastName: FormFieldValidation.NOT_VALIDATED,
    emailAddress: FormFieldValidation.NOT_VALIDATED,
    duration: FormFieldValidation.NOT_VALIDATED
});

const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

function validate(invite: IInvite, setValidation: (validation: IInviteValidation) => void) {
    const inviteeValidation = invite.invitees.map(invitee => ({
        firstName: invitee.firstName.trim().length > 0
            ? FormFieldValidation.VALID
            : FormFieldValidation.INVALID,

        lastName: invitee.lastName.trim().length > 0
            ? FormFieldValidation.VALID
            : FormFieldValidation.INVALID,

        emailAddress: invitee.emailAddress.trim().length > 0
            ? isValidEmail(invitee.emailAddress.trim())
                ? FormFieldValidation.VALID
                : FormFieldValidation.INVALID_EMAIL
            : FormFieldValidation.INVALID,

        duration: invitee.duration === -1 || invitee.duration > 0
            ? FormFieldValidation.VALID
            : FormFieldValidation.INVALID
    }));
    
    const validation: IInviteValidation = {
        invitees: inviteeValidation,

        reason: invite.reason.trim().length > 0
            ? FormFieldValidation.VALID
            : FormFieldValidation.INVALID
    };

    setValidation(validation);

    return  validation.reason === FormFieldValidation.VALID &&
            validation.invitees.every(i => Object.values(i).every(value => value === FormFieldValidation.VALID));
}

export { type IInviteValidation, type IInviteeValidation, createInviteeValidation, validate };